import styles from "./Title.module.scss";
import { OwnBrand } from "@/utils/product/getOwnBrand";
import { useEffect } from "react";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

type Props = {
  /**
   * The title of the product.
   */
  title: string;
  /**
   * The own brand of the product.
   */
  ownBrand: OwnBrand;
  /**
   * Any other brand of the product.
   */
  otherBrand: string;
  /**
   * Used to override the element used to render the component.
   */
  element: React.JSX.ElementType;
  /**
   * Used to remove h1 margin for beauty simplification work
   */
  simplifiedBeautyTitle?: boolean;
};

export function TitleUI({
  title,
  ownBrand,
  otherBrand,
  element,
  simplifiedBeautyTitle = false,
}: Props) {
  const Component = element;

  const headerClassNames = cx(styles.title, {
    simplifiedBeautyTitle: simplifiedBeautyTitle,
  });

  useEffect(() => {
    const breadcrumbs = document.querySelector('[data-testid="breadcrumbs"]');
    const branBreadcrumbLink = breadcrumbs?.querySelector('a[href^="/brand/"]');
    const brandLink = document.getElementById("pdp-brand-link");
    if (branBreadcrumbLink) {
      brandLink?.setAttribute(
        "href",
        branBreadcrumbLink.getAttribute("href") || "/",
      );
    } else {
      const lastLink = document.querySelector(
        '[data-testid="breadcrumbs"] ol > li:last-child > a',
      );
      if (lastLink) {
        brandLink?.setAttribute("href", lastLink.getAttribute("href") || "/");
      } else {
        brandLink?.setAttribute("href", "/");
      }
    }

    brandLink?.classList.add(styles.brandLink ?? "");
  }, []);

  return (
    <>
      <Component
        data-testid="product:title"
        className={headerClassNames}
        data-component="Title"
      >
        {ownBrand === "jl_own_brand_anyday_legacy" && (
          <a
            className={cx(styles.brand, styles.anydayLogo)}
            href="/"
            id="pdp-brand-link"
            data-testid="product:title:anyday"
          >
            ANYDAY
          </a>
        )}

        {ownBrand === "jl_own_brand_anyday" && (
          <a
            className={cx(styles.brand, styles.anydayLogo)}
            href="/"
            id="pdp-brand-link"
            data-testid="product:title:anyday"
          >
            <span className={styles.titlePrefix}>{`John Lewis `}</span>
            ANYDAY
          </a>
        )}

        {ownBrand === "jl_own_brand_john_lewis" && (
          <a
            className={styles.brand}
            href="/"
            id="pdp-brand-link"
            data-testid="product:title:johnlewis"
          >
            John Lewis
          </a>
        )}

        {!ownBrand && otherBrand && (
          <a
            className={styles.brand}
            id="pdp-brand-link"
            data-testid="product:title:otherBrand"
          >
            {otherBrand}
          </a>
        )}
        <span data-testid="product:title:content">{title}</span>
      </Component>
    </>
  );
}
